(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-nav"] && !Shopify.designMode) return;
  try {
    
(function(){
  function collectNavLinks(){
    const links = [...document.querySelectorAll('.ls__list .ls__link')];
    if (links.length) return links.map(a => ({ href: a.getAttribute('href') || '/', text: a.textContent.trim() }));
    const menu = [...document.querySelectorAll('nav a[href]')].slice(0,6);
    return menu.map(a => ({ href: a.getAttribute('href') || '/', text: a.textContent.trim() }));
  }

  function ensureDrawer(){
    let drawer  = document.querySelector('.ls__drawer');
    let backdrop= document.querySelector('.ls__backdrop');

    if (!drawer){
      drawer = document.createElement('div');
      drawer.className = 'ls__drawer';
      drawer.setAttribute('aria-hidden','true');
      drawer.setAttribute('role','dialog');
      drawer.setAttribute('aria-modal','true');
      drawer.setAttribute('aria-label','Site menu');
      drawer.innerHTML = `
        <button class="drawer__close" aria-label="Close menu">×</button>
        <ul class="drawer__list"></ul>
      `;
      document.body.appendChild(drawer);

      const ul = drawer.querySelector('.drawer__list');
      collectNavLinks().forEach(({href,text})=>{
        if (!text) return;
        const li = document.createElement('li');
        li.className = 'drawer__item';
        li.innerHTML = `<a class="drawer__link" href="${href}">${text}</a>`;
        ul.appendChild(li);
      });
    } else if (drawer.parentElement !== document.body){
      document.body.appendChild(drawer);
    }

    if (!backdrop){
      backdrop = document.createElement('div');
      backdrop.className = 'ls__backdrop';
      document.body.appendChild(backdrop);
    } else if (backdrop.parentElement !== document.body){
      document.body.appendChild(backdrop);
    }

    return {drawer, backdrop};
  }

  function ensureHamburger(){
    let btn = document.querySelector('.mobile-menu-btn');
    if (!btn){
      btn = document.createElement('button');
      btn.className = 'mobile-menu-btn';
      btn.setAttribute('aria-label','Open menu');
      btn.innerHTML = '<span class="bar"></span>';
      document.body.appendChild(btn);
    } else if (btn.parentElement !== document.body){
      document.body.appendChild(btn);
    }
    return btn;
  }

  function isSamePageAnchor(href){
    if (!href) return false;
    if (href.startsWith('#')) return true;
    try {
      const u = new URL(href, location.origin);
      return u.origin === location.origin &&
             u.pathname.replace(/\/+$/,'') === location.pathname.replace(/\/+$/,'') &&
             !!u.hash;
    } catch { return false; }
  }

  function scrollWithOffset(targetId){
    const el = document.getElementById(targetId);
    if (!el) return;
    const header = document.querySelector('.ls.sticky') || document.querySelector('.ls');
    const offset = (header ? header.offsetHeight : 0) + 12;
    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  function wire(btn, drawer, backdrop){
    if (!btn || !drawer || !backdrop) return;
    if (btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';

    const open = (e) => {
      e?.preventDefault();
      drawer.classList.add('open');
      backdrop.classList.add('open');
      drawer.setAttribute('aria-hidden','false');
      btn.setAttribute('aria-expanded','true');
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('menu-open');
    };

    const close = (e) => {
      e?.preventDefault();
      drawer.classList.remove('open');
      backdrop.classList.remove('open');
      drawer.setAttribute('aria-hidden','true');
      btn.setAttribute('aria-expanded','false');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('menu-open');
    };

    // Open: capture & stop so theme scripts can’t swallow the click
    btn.addEventListener('click', (e)=>{
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      open(e);
    }, {capture:true});

    backdrop.addEventListener('click', close);
    drawer.querySelector('.drawer__close')?.addEventListener('click', close);

    // Links: anchor vs normal navigation
    drawer.querySelectorAll('.drawer__link').forEach(a => {
      const href = a.getAttribute('href') || '';
      if (isSamePageAnchor(href)){
        a.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = href.startsWith('#') ? href.slice(1)
                           : (new URL(href, location.origin).hash || '').substring(1);
          close();
          setTimeout(() => scrollWithOffset(targetId), 120); // allow overflow unlock first
        });
      } else {
        // Different page: close drawer, then force navigation (beats preventDefault from themes)
        a.addEventListener('click', () => {
          const url = a.href;
          close();
          setTimeout(() => { window.location.href = url; }, 0);
        });
      }
    });

    // Esc key to close
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(e); });
  }

  function initSticky(){
    const nav = document.querySelector('.ls');
    const hero = document.querySelector('.video-hero-with-overlay, .vh, .hero, .hero-video, .video-section, .section-hero');
    if (!nav) return;
    const trigger = () => (hero?.offsetHeight || 200);
    const onScroll = ()=>{
      if (window.innerWidth >= 768 && window.scrollY > trigger()) nav.classList.add('sticky');
      else nav.classList.remove('sticky');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);
  }

  function boot(){
    const {drawer, backdrop} = ensureDrawer();
    const btn = ensureHamburger();
    wire(btn, drawer, backdrop);
    initSticky();
  }

  // Reveal hamburger after full load (preloader finished)
  function markReady(){ document.documentElement.classList.add('page-ready'); }

  if (document.getElementById('preloader')) {
    window.addEventListener('preloader:done', markReady, { once:true });
  } else {
    window.addEventListener('load', markReady, { once:true });
  }
  document.addEventListener('DOMContentLoaded', boot);
document.addEventListener('shopify:section:load', boot);
window.addEventListener('resize', () => {
  const {drawer, backdrop} = ensureDrawer();
  const btn = ensureHamburger();
  wire(btn, drawer, backdrop);
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-car"] && !Shopify.designMode) return;
  try {
    
(function(){
  const sec  = document.currentScript.closest('.ea');
  const rail = sec.querySelector('.ea__rail');
  const dotsWrap = sec.querySelector('.ea__dots');
  const cards = Array.from(rail.querySelectorAll('.ea-card'));
  if (!rail || cards.length < 2) return;

  // sizes
  const GAP = parseFloat(getComputedStyle(rail).gap) || 24;
  const STEP = () => cards[0].offsetWidth + GAP;

  // build dots to match cards
  dotsWrap.innerHTML = '';
  cards.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.className = 'ea__dot';
    dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    dot.addEventListener('click', () => { index = i; go(index); pause(); });
    dotsWrap.appendChild(dot);
  });
  const dots = Array.from(dotsWrap.querySelectorAll('.ea__dot'));

  let index = 0, timer = null, playing = true;

  function go(n){
    index = (n + cards.length) % cards.length;
    rail.scrollTo({ left: index * STEP(), behavior: 'smooth' });
    dots.forEach((d,k)=> d.setAttribute('aria-selected', k === index ? 'true' : 'false'));
  }

  function next(){
    const maxLeft = rail.scrollWidth - rail.clientWidth - 1;
    if (rail.scrollLeft >= maxLeft) { index = 0; go(index); return; }
    go(index + 1);
  }

  function start(){ clearInterval(timer); if (!playing) return; timer = setInterval(next, 3500); }
  function pause(ms=6000){ playing = false; clearInterval(timer); setTimeout(()=>{ playing = true; start(); }, ms); }

  // pause on hover (desktop)
  rail.addEventListener('mouseenter', ()=> pause());
  rail.addEventListener('mouseleave', ()=> { playing = true; start(); });

  // init
  go(0); start();

  // AJAX add to cart
  sec.addEventListener('click', async (e)=>{
    const b = e.target.closest('[data-add]'); if(!b) return;
    e.preventDefault();
    const vid = Number(b.getAttribute('data-vid')); if(!vid) return;
    b.disabled = true;
    try{
      const res = await fetch('/cart/add.js',{
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items:[{ id: vid, quantity: 1 }] })
      });
      if(!res.ok) throw await res.json();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      b.textContent = 'Added ✓';
      setTimeout(()=>{ b.textContent = '{{ section.settings.preorder_text }}'; b.disabled = false; }, 900);
    }catch(err){
      alert((err && err.description) || 'Unable to add to cart'); b.disabled = false;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-early-access-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:section:load', initEA);
document.addEventListener('DOMContentLoaded', initEA);

function initEA() {
  const secs = document.querySelectorAll('.ea');
  secs.forEach((sec) => {
    const rail = sec.querySelector('.ea__rail');
    const dotsWrap = sec.querySelector('.ea__dots');
    if (!rail) return;

    const cards = Array.from(rail.querySelectorAll('.ea-card'));
    if (cards.length < 2) return;

    // Build dots
    const GAP = parseFloat(getComputedStyle(rail).gap) || 24;
    const STEP = () => cards[0].offsetWidth + GAP;

    dotsWrap.innerHTML = '';
    cards.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'ea__dot';
      dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      dot.addEventListener('click', () => {
        index = i;
        go(index);
        pause();
      });
      dotsWrap.appendChild(dot);
    });
    const dots = Array.from(dotsWrap.querySelectorAll('.ea__dot'));

    let index = 0,
      timer = null,
      playing = true;

    function go(n) {
      index = (n + cards.length) % cards.length;
      rail.scrollTo({ left: index * STEP(), behavior: 'smooth' });
      dots.forEach((d, k) =>
        d.setAttribute('aria-selected', k === index ? 'true' : 'false')
      );
    }

    function next() {
      const maxLeft = rail.scrollWidth - rail.clientWidth - 1;
      if (rail.scrollLeft >= maxLeft) {
        index = 0;
        go(index);
        return;
      }
      go(index + 1);
    }

    function start() {
      clearInterval(timer);
      if (!playing) return;
      timer = setInterval(next, 3500);
    }

    function pause(ms = 6000) {
      playing = false;
      clearInterval(timer);
      setTimeout(() => {
        playing = true;
        start();
      }, ms);
    }

    rail.addEventListener('mouseenter', () => pause());
    rail.addEventListener('mouseleave', () => {
      playing = true;
      start();
    });

    go(0);
    start();

    // AJAX Add to cart / drawer support
    sec.addEventListener('click', async (e) => {
      const addButton = e.target.closest('[data-add], [data-cart-add]');
      if (!addButton) return;
      e.preventDefault();

      const vid = Number(addButton.getAttribute('data-vid'));
      if (!vid) return;

      addButton.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }),
        });

        if (!res.ok) throw await res.json();

        // ✅ Works with drawer OR page
        if (window.Shopify && window.Shopify.theme && window.Shopify.theme.cart) {
          window.Shopify.theme.cart.refresh();
        } else {
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error(err);
        alert(
          (err && err.description) || 'Unable to add to cart. Please try again.'
        );
      } finally {
        addButton.disabled = false;
      }
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  function collectNavLinks(){
    const links = [...document.querySelectorAll('.ls__list .ls__link')];
    if (links.length) return links.map(a => ({ href: a.getAttribute('href') || '/', text: a.textContent.trim() }));
    const menu = [...document.querySelectorAll('nav a[href]')].slice(0,6);
    return menu.map(a => ({ href: a.getAttribute('href') || '/', text: a.textContent.trim() }));
  }

  function ensureDrawer(){
    let drawer  = document.querySelector('.ls__drawer');
    let backdrop= document.querySelector('.ls__backdrop');

    if (!drawer){
      drawer = document.createElement('div');
      drawer.className = 'ls__drawer';
      drawer.setAttribute('aria-hidden','true');
      drawer.setAttribute('role','dialog');
      drawer.setAttribute('aria-modal','true');
      drawer.setAttribute('aria-label','Site menu');
      drawer.innerHTML = `
        <button class="drawer__close" aria-label="Close menu">×</button>
        <ul class="drawer__list"></ul>
      `;
      document.body.appendChild(drawer);

      const ul = drawer.querySelector('.drawer__list');
      collectNavLinks().forEach(({href,text})=>{
        if (!text) return;
        const li = document.createElement('li');
        li.className = 'drawer__item';
        li.innerHTML = `<a class="drawer__link" href="${href}">${text}</a>`;
        ul.appendChild(li);
      });
    } else if (drawer.parentElement !== document.body){
      document.body.appendChild(drawer);
    }

    if (!backdrop){
      backdrop = document.createElement('div');
      backdrop.className = 'ls__backdrop';
      document.body.appendChild(backdrop);
    } else if (backdrop.parentElement !== document.body){
      document.body.appendChild(backdrop);
    }

    return {drawer, backdrop};
  }

  function ensureHamburger(){
    let btn = document.querySelector('.mobile-menu-btn');
    if (!btn){
      btn = document.createElement('button');
      btn.className = 'mobile-menu-btn';
      btn.setAttribute('aria-label','Open menu');
      btn.innerHTML = '<span class="bar"></span>';
      document.body.appendChild(btn);
    } else if (btn.parentElement !== document.body){
      document.body.appendChild(btn);
    }
    return btn;
  }

  function isSamePageAnchor(href){
    if (!href) return false;
    if (href.startsWith('#')) return true;
    try {
      const u = new URL(href, location.origin);
      return u.origin === location.origin &&
             u.pathname.replace(/\/+$/,'') === location.pathname.replace(/\/+$/,'') &&
             !!u.hash;
    } catch { return false; }
  }

  function scrollWithOffset(targetId){
    const el = document.getElementById(targetId);
    if (!el) return;
    const header = document.querySelector('.ls.sticky') || document.querySelector('.ls');
    const offset = (header ? header.offsetHeight : 0) + 12;
    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  function wire(btn, drawer, backdrop){
    if (!btn || !drawer || !backdrop) return;
    if (btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';

    const open = (e) => {
      e?.preventDefault();
      drawer.classList.add('open');
      backdrop.classList.add('open');
      drawer.setAttribute('aria-hidden','false');
      btn.setAttribute('aria-expanded','true');
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('menu-open');
    };

    const close = (e) => {
      e?.preventDefault();
      drawer.classList.remove('open');
      backdrop.classList.remove('open');
      drawer.setAttribute('aria-hidden','true');
      btn.setAttribute('aria-expanded','false');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('menu-open');
    };

    // Open: capture & stop so theme scripts can’t swallow the click
    btn.addEventListener('click', (e)=>{
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      open(e);
    }, {capture:true});

    backdrop.addEventListener('click', close);
    drawer.querySelector('.drawer__close')?.addEventListener('click', close);

    // Links: anchor vs normal navigation
    drawer.querySelectorAll('.drawer__link').forEach(a => {
      const href = a.getAttribute('href') || '';
      if (isSamePageAnchor(href)){
        a.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = href.startsWith('#') ? href.slice(1)
                           : (new URL(href, location.origin).hash || '').substring(1);
          close();
          setTimeout(() => scrollWithOffset(targetId), 120); // allow overflow unlock first
        });
      } else {
        // Different page: close drawer, then force navigation (beats preventDefault from themes)
        a.addEventListener('click', () => {
          const url = a.href;
          close();
          setTimeout(() => { window.location.href = url; }, 0);
        });
      }
    });

    // Esc key to close
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(e); });
  }

  function initSticky(){
    const nav = document.querySelector('.ls');
    const hero = document.querySelector('.video-hero-with-overlay, .vh, .hero, .hero-video, .video-section, .section-hero');
    if (!nav) return;
    const trigger = () => (hero?.offsetHeight || 200);
    const onScroll = ()=>{
      if (window.innerWidth >= 768 && window.scrollY > trigger()) nav.classList.add('sticky');
      else nav.classList.remove('sticky');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);
  }

  function boot(){
    const {drawer, backdrop} = ensureDrawer();
    const btn = ensureHamburger();
    wire(btn, drawer, backdrop);
    initSticky();
  }

  // Reveal hamburger after full load (preloader finished)
  function markReady(){ document.documentElement.classList.add('page-ready'); }

  if (document.getElementById('preloader')) {
    window.addEventListener('preloader:done', markReady, { once:true });
  } else {
    window.addEventListener('load', markReady, { once:true });
  }
  document.addEventListener('DOMContentLoaded', boot);
document.addEventListener('shopify:section:load', boot);
window.addEventListener('resize', () => {
  const {drawer, backdrop} = ensureDrawer();
  const btn = ensureHamburger();
  wire(btn, drawer, backdrop);
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero-with-overlay"] && !Shopify.designMode) return;
  try {
    
/* Robust event delegation so it works in Theme Editor and live */
(function() {
  // Open the modal for the section that contains the clicked button
  function openFor(button){
    const root  = button.closest('[id^="shopify-section-"]');
    if (!root) return;
    const modal = root.querySelector('.vh-modal');
    const panel = modal?.querySelector('.vh-modal__panel');
    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    panel && panel.focus();
    document.documentElement.style.overflow = 'hidden';

    // Store focus to restore later
    modal._lastFocus = document.activeElement;

    // Trap focus + Esc to close
    function trap(e){
      if (e.key === 'Escape'){ closeFor(modal); return; }
      if (e.key !== 'Tab') return;
      const f = modal.querySelectorAll('a,button,textarea,input,select,[tabindex]:not([tabindex="-1"])');
      const list = Array.from(f).filter(el => !el.disabled);
      if (!list.length) return;
      const first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first){ last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last){ first.focus(); e.preventDefault(); }
    }
    modal._trap = trap;
    document.addEventListener('keydown', trap);
  }

  function closeFor(modal){
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.removeEventListener('keydown', modal._trap || (()=>{}));
    document.documentElement.style.overflow = '';
    if (modal._lastFocus && typeof modal._lastFocus.focus === 'function'){
      modal._lastFocus.focus();
    }
  }

  // Delegate clicks
  document.addEventListener('click', function(e){
    const openBtn = e.target.closest('.js-vh-open');
    if (openBtn){ e.preventDefault(); openFor(openBtn); return; }

    const closeBtn = e.target.closest('.js-vh-close');
    if (closeBtn){
      const modal = closeBtn.closest('.vh-modal');
      if (modal){ e.preventDefault(); closeFor(modal); }
      return;
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
